exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2b9dea6a] .drawer{margin:0;height:100vh;max-height:100vh;border-radius:0;transition:transform .5s}[data-v-2b9dea6a] .none-enter-active,[data-v-2b9dea6a] .none-leave-active{transform:translateX(100%)}.v-dialog__content[data-v-2b9dea6a]{justify-content:flex-end}", ""]);

// exports
